import InvoiceReconDash from "./InvoiceReconDash";
import ReturnsDash from "./ReturnsDash";
import SupplyChainDash from "./SupplyChainDash";
import AutomationFlow from "./AutomationFlow";
import ProcessExample from "./ProcessExample";

export function CaseVisual({ cs, dashboards, process }) {
  switch (cs.visual) {
    case "invoice-recon":
      return <InvoiceReconDash rows={dashboards.invoices || []} />;
    case "returns":
      return <ReturnsDash rows={dashboards.returns || []} />;
    case "supply-chain":
      return <SupplyChainDash rows={dashboards.supplychain || []} />;
    case "automation":
      return <AutomationFlow />;
    case "process":
      return process ? <ProcessExample process={process} /> : null;
    default:
      return null;
  }
}
